import { createUseStyles } from 'react-jss';
import { IonButton, IonText } from '@ionic/react';
import { CheckmarkIcon } from '../components/icons/Icons.tsx';
import { ReactNode } from 'react';
import { Color } from '../components/common/index.ts';

type IStyleKeys = 'button' | 'badge';

interface IStyleProps {
    isActive?: boolean;
}

const useStyles = createUseStyles<IStyleKeys, IStyleProps>({
    button: {
        height: 'unset',
        textAlign: 'left',
        borderRadius: 10,
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
        '--background-activated-opacity': 0.2,
        '--border-color': ({isActive}) => isActive ? 'primary' : 'var(--ion-color-step-150)',
        '--padding-start': '14px',
        '--padding-end': '14px',
        '--padding-top': '16px',
        '--padding-bottom': '16px',
        '--background': 'white',
        '&:hover': {
            opacity: 1
        },
        '&::part(native)': {
            borderWidth: 2
        }
    },
    badge: {
        position: 'absolute',
        top: -13,
        zIndex: 1,
        padding: '4px 15px',
        color: 'white',
        fontSize: 13,
        fontWeight: 600,
        borderRadius: 20,
    }
});

export const PaymentTermButton: React.FC<{ disabled: boolean; isActive: boolean; onClick: () => void; termLabel: string; termDescription: ReactNode; badge?: string; badgeAlignment?: 'left' | 'right', badgeBackground?: string, badgeTextColor?: Color }> = ({ disabled, isActive, onClick, termLabel, termDescription, badge, badgeAlignment, badgeBackground, badgeTextColor }) => {
    const classes = useStyles({ isActive });

    const badgeLeft = (badgeAlignment === 'left' ? 20 : undefined);
    const badgeRight = (badgeAlignment !== 'left' ? 20 : undefined);
    const badgeColor = badgeTextColor ? `var(--ion-color-${badgeTextColor})` : undefined;
    badgeBackground = badgeBackground || 'linear-gradient(90deg, #5768D1 0%, #2D356B 100%)';

    return (
        <div style={{position: 'relative', marginTop: 8, marginBottom: 8}}>

            {badge && (
                <div className={classes.badge} style={{left: badgeLeft, right: badgeRight, background: badgeBackground, color: badgeColor}}>
                    {badge}
                </div>
            )}

            <IonButton
                disabled={disabled}
                expand="block"
                fill="outline"
                className={`ion-text-wrap ${classes.button}`}
                onClick={onClick}
            >
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8, width: '100%'}}>
                    <IonText style={{color: 'var(--ion-text-color)', fontSize: 16, marginRight: -20}}><b>{termLabel}</b></IonText>
                    <IonText color="medium" style={{fontSize: 14}}><b>{termDescription}</b></IonText>
                </div>

                <div slot="end" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    width: 32, height: 32, borderRadius: '50%',
                    backgroundColor: isActive ? 'var(--ion-color-primary)' : 'transparent',
                }}>
                    {isActive && (
                        <CheckmarkIcon color="light" size="medium" strokeWidth={75} />
                    )}
                </div>
            </IonButton>
        </div>
    );
};
